export enum Multiplier {
  UNIT = 0,
  USER = 1,
  NONE = 2,
}
